import { getSlugValue } from 'utilities/getSlugValue';

export const VALUATION_APPROACHES_TEST_IDS = {
  approachMenu: 'valuation-approach-tab-menu',
  approachMenuAction: (actionText: string) => `valuation-approach-menu__${getSlugValue(actionText)}`,
  addApproachOption: (approachName: string) => `valuation-add-approach__${getSlugValue(approachName)}`,
  approachDialogNameInput: 'valuation-approach-dialog__name-input',
  approachDialogSaveButton: 'valuation-approach-dialog__save-button',
  secondaryNavEquityValue: 'valuation-secondary-navigation__equity-value',
  secondaryNavUnrealizedFirmTotal: 'valuation-secondary-navigation__unrealized-firm-total',
} as const;
